import { signal } from "@preact/signals-react"

export const brand = signal([])
export const category = signal([])
export const googleCategory = signal([])
export const categoryFake = signal([])
export const sku = signal([])
export const skuGroup = signal(null)
export const renderSkuGroup = signal(true)
export const skuGroupData = signal([])
export const isOpenSkuGroupModal = signal(false)
export const lostBuyBoxReason = signal([])
export const productsInStock = signal(false)
export const company = signal([])